// extracted by mini-css-extract-plugin
export var avatar = "_r7-3";
export var avatarContainer = "_r7-2";
export var avatarSpacer = "_r7-5";
export var avatarSpacerContainer = "_r7-4";
export var avatarStackContainer = "_r7-1";
export var bubble = "_r7-0";
export var remainderBubble = "_r7-6";